import React from 'react'
import { SvgProps } from '../../app/types/common'
import { ReactComponent as WavingHandSvg } from './waving-hand-icon.svg'
import { ReactComponent as ConsultationDocumentSvg } from './acts/icon-consultation-document.svg'
import { ReactComponent as TransmissionDocumentSvg } from './acts/icon-transmission-document.svg'
import { ReactComponent as ActDocumentSvg } from './acts/act-document-icon.svg'
import { ReactComponent as PatientRecordSvg } from './patient-record-icon.svg'
import { ReactComponent as PhoneBackgroundSvg } from './icon-phone-withbackground.svg'
import { ReactComponent as ToothlessSvg } from './toothless.svg'
import { ReactComponent as WarningIconSvg } from './warning-red-background-icon.svg'
import { ReactComponent as PatientHeartSvg } from './patient-heart-icon.svg'
import { ReactComponent as HcsBuildingSvg } from './hcs-building-icon.svg'
import { ReactComponent as InfoIconSvg } from './navigation/icon-info.svg'
import { ReactComponent as AnnouncementIconSvg } from './navigation/icon-announcement.svg'

import { ReactComponent as PatientRecordPrescriptionSvg } from './patientRecord/patient-record-prescription-icon.svg'
import { ReactComponent as PatientRecordPrescriptionConsultationSvg } from './patientRecord/patient-record-prescription-consultation-icon.svg'
import { ReactComponent as PatientRecordPrescriptionTransmissionSvg } from './patientRecord/patient-record-prescription-transmission-icon.svg'

import { ReactComponent as PatientRecordWebPs } from './icon-webps.svg'
import { ReactComponent as NewsSvg } from './navigation/icon-news.svg'
import { ReactComponent as NewsActiveSvg } from './navigation/active/icon-news-active.svg'

import { ReactComponent as ArrowOutwardSvg } from './navigation/icon-arrow-outward.svg'
import { ReactComponent as ArrowOutwardRoundedSvg } from './icon-arrow-outward-rounded.svg' // icon above have a fixed color (white), replace by this one with parameterizable color.

import { ReactComponent as CircleIconSvg } from './icon-circle.svg'
import { ReactComponent as FolderSharedSvg } from './icon-folder-shared.svg'

import { ReactComponent as CloseIconSvg } from './icon-close.svg'
import { ReactComponent as IconTrashSvg } from './actions/icon-trash.svg'
import { ReactComponent as IconEyeSvg } from './actions/icon-eye.svg'
import { ReactComponent as AutosaveIconSvg } from './autosave-icon.svg'
import { ReactComponent as UnsavedAutosaveIconSvg } from './unsaved-autosave-icon.svg'
import { ReactComponent as SavingAutosaveIconSvg } from './saving-autosave-icon.svg'
import { ReactComponent as LogoGreenSvg } from './logos/ttd-logo-green.svg'
import { ReactComponent as LogoSvg } from './logos/ttd-logo-primary.svg'
import { ReactComponent as PatientIconSvg } from './patient-icon.svg'
import { ReactComponent as PatientIconWhiteSvg } from './patient-icon-white.svg'
import { ReactComponent as PhoneIconSvg } from './icon-phone.svg'
import { ReactComponent as ExternalArrowIconSvg } from './external-arrow-icon.svg'
import { ReactComponent as MicOnIconSvg } from './micro/icon-micro-on.svg'
import { ReactComponent as MicOffIconSvg } from './micro/icon-micro-off.svg'
import { ReactComponent as CameraOnIconSvg } from './camera/icon-camera-on.svg'
import { ReactComponent as CameraOffIconSvg } from './camera/icon-camera-off.svg'
import { ReactComponent as EnterFullScreenIconSvg } from './call/icon-enter-fullscreen.svg'
import { ReactComponent as ExitFullScreenIconSvg } from './call/icon-exit-fullscreen.svg'
import { ReactComponent as MicDisabledIconSvg } from './micro/icon-micro-disabled-red.svg'
import { ReactComponent as CameraDisabledIconSvg } from './camera/icon-camera-disabled-red.svg'
import { ReactComponent as EmptyPatientIconSvg } from './call/icon-empty-patient.svg'
import { ReactComponent as IconCameraParticipantOffSvg } from './camera/icon-camera-participant-off.svg'

import { ReactComponent as ReloadIconSvg } from './icon-reload.svg'
import { ReactComponent as DangerIconSvg } from './icon-danger.svg'
import { ReactComponent as ErrorIconSvg } from './icon-error.svg'
import { ReactComponent as StethoIconSvg } from './call/icon-stetho-color.svg'
import { ReactComponent as StethoIconWhiteSvg } from './call/icon-stetho.svg'
import { ReactComponent as ConsultationWhiteIconSvg } from './navigation/icon-tlc-white.svg'
import { ReactComponent as TransmissionColorIconSvg } from './navigation/icon-tle-purple.svg'
import { ReactComponent as DownloadIconSvg } from './icon-download.svg'
import { ReactComponent as SettingsIconSvg } from './icon-settings-dark.svg'
import { ReactComponent as DownloadIconAllSvg } from './actions/icon-download-all.svg'
import { ReactComponent as IconEditSvg } from './actions/icon-edit.svg'
import { ReactComponent as IconEditRoundedSvg } from './actions/icon-edit-rounded.svg'
import { ReactComponent as LogotypeSvg } from './logos/ttd-logotype.svg'
import { ReactComponent as ConsultationIconSvg } from './notifications/consultation-icon.svg'
import { ReactComponent as TransmissionIconSvg } from './notifications/transmission-icon.svg'
import { ReactComponent as ConsultationsIconSvg } from './navigation/icon-tlc.svg'
import { ReactComponent as TransmissionsIconSvg } from './navigation/icon-tle.svg'
import { ReactComponent as HelpIconSvg } from './navigation/icon-help.svg'
import { ReactComponent as VerifiedIconSvg } from './verified-user.svg'
import { ReactComponent as HelpWhiteIconSvg } from './navigation/icon-help-white.svg'
import { ReactComponent as HistoryIconSvg } from './navigation/icon-history.svg'
import { ReactComponent as ConsultationsIconActiveSvg } from './navigation/active/icon-tlc-active.svg'
import { ReactComponent as TransmissionsIconActiveSvg } from './navigation/active/icon-tle-active.svg'
import { ReactComponent as HelpIconActiveSvg } from './navigation/active/icon-help-active.svg'
import { ReactComponent as HistoryIconActiveSvg } from './navigation/active/icon-history-active.svg'
import { ReactComponent as DrugIconSvg } from './prescription/prescription-drug-icon.svg'
import { ReactComponent as ClassicIconSvg } from './prescription/prescription-classic-icon.svg'
import { ReactComponent as BizoneIconSvg } from './prescription/prescription-bizone-icon.svg'
import { ReactComponent as AddressLetterIconSvg } from './prescription/prescription-addressletter-icon.svg'
import { ReactComponent as ExternalIconSvg } from './prescription/prescription-external-icon.svg'
import { ReactComponent as LocationIconSvg } from './icon-location-filled.svg'
import { ReactComponent as PostponeTlcIconSvg } from './call/icon-tlc-postpone.svg'
import { ReactComponent as StartTlcIconSvg } from './call/icon-camera-full.svg'
import { ReactComponent as PatientStarIconSvg } from './icon-patient-star.svg'
import { ReactComponent as DownloadButtonIconSummarySvg } from './history/icon-summary.svg'
import { ReactComponent as DownloadButtonIconPrescriptionSvg } from './history/icon-prescription.svg'
import { ReactComponent as DownloadButtonIconCareDocumentSvg } from './history/icon-medical-paper.svg'
import { ReactComponent as InvoiceIconSvg } from './history/icon-invoice.svg'
import { ReactComponent as DmpIconSvg } from './history/icon-dmp.svg'
import { ReactComponent as AttachmentIconSvg } from './actions/icon-attachment.svg'
import { ReactComponent as SaveIconSvg } from './actions/icon-save.svg'
import { ReactComponent as CancelIconSvg } from './actions/icon-cancel.svg'
import { ReactComponent as PlusIconSvg } from './actions/icon-plus.svg'
import { ReactComponent as ArrowDownIconSvg } from './icon-arrow-down.svg'
import { ReactComponent as CheckSingleIconSvg } from './icon-check-single.svg'

import { ReactComponent as SignalGreenSvg } from './signal/icon-signal-green.svg'
import { ReactComponent as SignalYellowSvg } from './signal/icon-signal-yellow.svg'
import { ReactComponent as SignalRedSvg } from './signal/icon-signal-red.svg'
import { ReactComponent as GreySignalIconSvg } from './signal/icon-signal-grey.svg'

import { ReactComponent as DocumentIconSvg } from './docs/icon-doc-pdf.svg'
import { ReactComponent as InsertDriveFileDoneIconSvg } from './docs/icon-insert-drive-file-done.svg'

import { ReactComponent as EmptyPrescriptionEmptyStateSvg } from './emptyStates/empty-prescription-empty-state.svg'

import { ReactComponent as GoogleChromeSvg } from './icon-google-chrome.svg'
import { ReactComponent as FirefoxSvg } from './icon-firefox.svg'

export const WavingHandIcon = (props: SvgProps) => <WavingHandSvg {...props} />
export const ConsultationDocumentIcon = (props: SvgProps) => <ConsultationDocumentSvg {...props} />
export const TransmissionDocumentIcon = (props: SvgProps) => <TransmissionDocumentSvg {...props} />
export const ActDocumentIcon = (props: SvgProps) => <ActDocumentSvg {...props} />
export const PatientRecordIcon = (props: SvgProps) => <PatientRecordSvg {...props} />
export const PatientRecordWebPsIcon = (props: SvgProps) => <PatientRecordWebPs {...props} />
export const PhoneBackgroundIcon = (props: SvgProps) => <PhoneBackgroundSvg {...props} />
export const ToothlessIcon = (props: SvgProps) => <ToothlessSvg {...props} />
export const WarningIcon = (props: SvgProps) => <WarningIconSvg {...props} />
export const PatientHeartIcon = (props: SvgProps) => <PatientHeartSvg {...props} />
export const HcsBuildingIcon = (props: SvgProps) => <HcsBuildingSvg {...props} />
export const InfoIcon = (props: SvgProps) => <InfoIconSvg {...props} />
export const AnnouncementIcon = (props: SvgProps) => <AnnouncementIconSvg {...props} />

export const PatientRecordPrescriptionIcon = (props: SvgProps) => <PatientRecordPrescriptionSvg {...props} />
export const PatientRecordPrescriptionConsultationIcon = (props: SvgProps) => (
    <PatientRecordPrescriptionConsultationSvg {...props} />
)
export const PatientRecordPrescriptionTransmissionIcon = (props: SvgProps) => (
    <PatientRecordPrescriptionTransmissionSvg {...props} />
)

export const NewsIcon = (props: SvgProps) => <NewsSvg {...props} />
export const NewsActiveIcon = (props: SvgProps) => <NewsActiveSvg {...props} />

export const ArrowOutwardIcon = (props: SvgProps) => <ArrowOutwardSvg {...props} />
export const ArrowOutwardRoundedIcon = (props: SvgProps) => <ArrowOutwardRoundedSvg {...props} />

export const CircleIcon = (props: SvgProps) => <CircleIconSvg {...props} />
export const FolderSharedIcon = (props: SvgProps) => <FolderSharedSvg {...props} />

export const CloseIcon = (props: SvgProps) => <CloseIconSvg {...props} />
export const IconTrash = (props: SvgProps) => <IconTrashSvg {...props} />
export const IconEye = (props: SvgProps) => <IconEyeSvg {...props} />
export const AutosaveIcon = (props: SvgProps) => <AutosaveIconSvg {...props} />
export const UnsavedAutosaveIcon = (props: SvgProps) => <UnsavedAutosaveIconSvg {...props} />
export const SavingAutosaveIcon = (props: SvgProps) => <SavingAutosaveIconSvg {...props} />
export const LogoGreen = (props: SvgProps) => <LogoGreenSvg {...props} />
export const Logo = (props: SvgProps) => <LogoSvg {...props} />
export const PatientIcon = (props: SvgProps) => <PatientIconSvg {...props} />
export const PatientIconWhite = (props: SvgProps) => <PatientIconWhiteSvg {...props} />
export const PhoneIcon = (props: SvgProps) => <PhoneIconSvg {...props} />
export const ExternalArrowIcon = (props: SvgProps) => <ExternalArrowIconSvg {...props} />
export const MicOnIcon = (props: SvgProps) => <MicOnIconSvg {...props} />
export const MicOffIcon = (props: SvgProps) => <MicOffIconSvg {...props} />
export const CameraOnIcon = (props: SvgProps) => <CameraOnIconSvg {...props} />
export const CameraOffIcon = (props: SvgProps) => <CameraOffIconSvg {...props} />
export const EnterFullScreenIcon = (props: SvgProps) => <EnterFullScreenIconSvg {...props} />
export const ExitFullScreenIcon = (props: SvgProps) => <ExitFullScreenIconSvg {...props} />
export const MicDisabledIcon = (props: SvgProps) => <MicDisabledIconSvg {...props} />
export const CameraDisabledIcon = (props: SvgProps) => <CameraDisabledIconSvg {...props} />
export const EmptyPatientIcon = (props: SvgProps) => <EmptyPatientIconSvg {...props} />
export const IconCameraParticipantOff = (props: SvgProps) => <IconCameraParticipantOffSvg {...props} />
export const GreySignalIcon = (props: SvgProps) => <GreySignalIconSvg {...props} />
export const ReloadIcon = (props: SvgProps) => <ReloadIconSvg {...props} />
export const DangerIcon = (props: SvgProps) => <DangerIconSvg {...props} />
export const ErrorIcon = (props: SvgProps) => <ErrorIconSvg {...props} />
export const StethoIcon = (props: SvgProps) => <StethoIconSvg {...props} />
export const StethoIconWhite = (props: SvgProps) => <StethoIconWhiteSvg {...props} />
export const ConsultationWhiteIcon = (props: SvgProps) => <ConsultationWhiteIconSvg {...props} />
export const TransmissionColorIcon = (props: SvgProps) => <TransmissionColorIconSvg {...props} />
export const DownloadIcon = (props: SvgProps) => <DownloadIconSvg {...props} />
export const SettingsIcon = (props: SvgProps) => <SettingsIconSvg {...props} />
export const DownloadIconAll = (props: SvgProps) => <DownloadIconAllSvg {...props} />
export const IconEdit = (props: SvgProps) => <IconEditSvg {...props} />
export const IconEditRounded = (props: SvgProps) => <IconEditRoundedSvg {...props} />
export const Logotype = (props: SvgProps) => <LogotypeSvg {...props} />
export const ConsultationIcon = (props: SvgProps) => <ConsultationIconSvg {...props} />
export const TransmissionIcon = (props: SvgProps) => <TransmissionIconSvg {...props} />
export const ConsultationsIcon = (props: SvgProps) => <ConsultationsIconSvg {...props} />
export const TransmissionsIcon = (props: SvgProps) => <TransmissionsIconSvg {...props} />
export const HelpIcon = (props: SvgProps) => <HelpIconSvg {...props} />
export const VerifiedUserIcon = (props: SvgProps) => <VerifiedIconSvg {...props} />
export const HelpWhiteIcon = (props: SvgProps) => <HelpWhiteIconSvg {...props} />
export const HistoryIcon = (props: SvgProps) => <HistoryIconSvg {...props} />
export const ConsultationsIconActive = (props: SvgProps) => <ConsultationsIconActiveSvg {...props} />
export const TransmissionsIconActive = (props: SvgProps) => <TransmissionsIconActiveSvg {...props} />
export const HelpIconActive = (props: SvgProps) => <HelpIconActiveSvg {...props} />
export const HistoryIconActive = (props: SvgProps) => <HistoryIconActiveSvg {...props} />
export const DrugIcon = (props: SvgProps) => <DrugIconSvg {...props} />
export const ClassicIcon = (props: SvgProps) => <ClassicIconSvg {...props} />
export const BizoneIcon = (props: SvgProps) => <BizoneIconSvg {...props} />
export const AddressLetterIcon = (props: SvgProps) => <AddressLetterIconSvg {...props} />
export const ExternalIcon = (props: SvgProps) => <ExternalIconSvg {...props} />
export const LocationIcon = (props: SvgProps) => <LocationIconSvg {...props} />
export const PostponeTlcIcon = (props: SvgProps) => <PostponeTlcIconSvg {...props} />
export const StartTlcIcon = (props: SvgProps) => <StartTlcIconSvg {...props} />
export const PatientStarIcon = (props: SvgProps) => <PatientStarIconSvg {...props} />
export const DownloadButtonIconSummary = (props: SvgProps) => <DownloadButtonIconSummarySvg {...props} />
export const DownloadButtonIconPrescription = (props: SvgProps) => <DownloadButtonIconPrescriptionSvg {...props} />
export const DownloadButtonIconCareDocument = (props: SvgProps) => <DownloadButtonIconCareDocumentSvg {...props} />
export const InvoiceIcon = (props: SvgProps) => <InvoiceIconSvg {...props} />
export const DmpIcon = (props: SvgProps) => <DmpIconSvg {...props} />
export const AttachmentIcon = (props: SvgProps) => <AttachmentIconSvg {...props} />
export const SaveIcon = (props: SvgProps) => <SaveIconSvg {...props} />
export const CancelIcon = (props: SvgProps) => <CancelIconSvg {...props} />
export const PlusIcon = (props: SvgProps) => <PlusIconSvg {...props} />
export const ArrowDownIcon = (props: SvgProps) => <ArrowDownIconSvg {...props} />
export const CheckSingleIcon = (props: SvgProps) => <CheckSingleIconSvg {...props} />

export const SignalGreenIcon = (props: SvgProps) => <SignalGreenSvg {...props} />
export const SignalYellowIcon = (props: SvgProps) => <SignalYellowSvg {...props} />
export const SignalRedIcon = (props: SvgProps) => <SignalRedSvg {...props} />
export const DocumentIcon = (props: SvgProps) => <DocumentIconSvg {...props} />
export const InsertDriveFileDoneIcon = (props: SvgProps) => <InsertDriveFileDoneIconSvg {...props} />

export const EmptyPrescriptionEmptyState = (props: SvgProps) => <EmptyPrescriptionEmptyStateSvg {...props} />

export const GoogleChromeIcon = (props: SvgProps) => <GoogleChromeSvg {...props} />
export const FirefoxIcon = (props: SvgProps) => <FirefoxSvg {...props} />
